import { Component, inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { FcmService } from '@core/services/fcm-message/fcm.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'web-admin-frontend';
  private fcmService = inject(FcmService);

  constructor(private matIconReg: MatIconRegistry){
    
  }

  ngOnInit(): void {
    this.fcmService.listenToForegroundMessages();
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }
}
